<template>
  <div class="app_container">
    <search class="search-wrapper" @search="searchHandle" />
    <div class="total-credit">
      <span>合计总学时{{creditData.totalCredit}}分，</span>
      <span>浙里学习合计学时{{creditData.appWebCredit}}分，</span>
      <span>我的学习小程序合计学时{{creditData.dingCredit}}分，</span>
      <span>单位总数{{creditData.deptNum}}，</span>
      <span>平均合计学时{{creditData.avgCredit}}分 </span>
      <butn btntype="primary" title="列表导出" v-permission="'unitCredit:listExport'" @click.native="listExport"></butn>
      <butn btntype="primary" title="报表导出" v-permission="'unitCredit:reportExport'" @click.native="reportExport"></butn>
    </div>
    <el-table
      ref="pageListTable"
      :data="list"
      border 
      :cell-style="{ color: '#51627D', fontWeight: 400, textAlign: 'center'}"
      :header-cell-style="{ background: '#DCE7FA', color: '#343C4A', fontWeight: 500, textAlign: 'center'}"
    >
      <template
        v-for="(item, index) in tableColumn"
      > 
        <el-table-column
          :key="index"
          class-name="train-list-column"
          v-bind="item"
          :width="item.width"
        />
      </template>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="currentPage"
      :page-size="size"
      :page-sizes="[10, 50, 100, 500, 1000]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
    />
    <ReportExport v-if="exportDialog.flag" :exportDialog="exportDialog" @confirm="exportConfirm"/>
  </div>
</template>

<script>
import { exportUnitCreditList, exportUnitCreditReport, unitCreditList } from "@/api/creditStatistics";
import butn from "@/components/button/index";
import { ioRead } from "@/utils/common";
import ReportExport from "./reportExportDialog.vue";
import Search from "./search";
export default {
  name: "creditStatistics",
  components: {
    Search,
    butn,
    ReportExport
  },
  data() {
    return {
      creditData: {
        appWebCredit: 0,
        avgCredit: 0,
        deptNum: 0,
        dingCredit: 0,
        totalCredit: 0,
      },
      list: [],
      searchValue: {},
      currentPage: 1,
      size: 10,
      total: 0,
      exportDialog: {
        flag: false,
      },
      tableColumn: [
        { 
          prop: "topDeptName", 
          label: "所属分院" ,
          minWidth: "100",
        },
        { 
          prop: "deptName", 
          label: "工作单位", 
          minWidth: "200", 
          checkbox: true,
        },
        {
          prop: "appWebCredit",
          label: "浙里学习获得学时",
          minWidth: "100",
          checkbox: true
        },
        {
          prop: "dingCredit",
          label: "我的学习小程序获得学时",
          minWidth: "120",
          checkbox: true,
        },
        {
          prop: "totalCredit",
          label: "合计总学时",
          minWidth: "100",
          checkbox: true,
        }
      ],
    };
  },
  created() {
    
  },
  methods: {
    //   搜索
    searchHandle(params) {
      this.searchValue = params;
      this.currentPage = 1;
      this.getList();
    },

    getList() {
      unitCreditList({
        ...this.searchValue,
        page: this.currentPage,
        limit: this.size,
      }).then(({code, data}) => {
        if (code != 0) return;
        this.total = Number(data.total);
        this.creditData = {
          appWebCredit: data.appWebCredit || 0,
          avgCredit: data.avgCredit || 0,
          deptNum: data.deptNum || 0,
          dingCredit: data.dingCredit || 0,
          totalCredit: data.totalCredit || 0,
        }
        let flatList = [];
        if (Array.isArray(data.records) && data.records.length) {
          flatList = data.records;
        }
        this.list = flatList;
      });
    },
    // 列表导出
    listExport() {
      exportUnitCreditList({ ...this.searchValue }).then(res => {
        ioRead(res);
      })
    },
    // 报表导出
    reportExport() {
      this.exportDialog.flag = true;      
    },
    exportConfirm(val) {
      exportUnitCreditReport({ ...val }).then(res => {
        this.exportDialog.flag = false;
        ioRead(res);
      })
    },
    sizeChange(size) {
      this.size = size;
      this.getList();
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
  },
  // computed: {
  //   examPaperIds() {
  //     return this.checkArray.map((item) => item.uuid);
  //   },
  // },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 10px;
}
.table-column-check-list {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  /deep/ .el-checkbox-group {
    display: flex;
    margin-top: 10px;
    margin-left: 20px;
    flex-direction: row;
    flex-wrap: wrap;
    
    .el-checkbox {
      margin-right: 15px;
      margin-bottom: 5px;
      display: flex;
      flex-direction: row;
    }
  }
}

.checkBoxLabel {
  max-width: 120px;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.total-credit {
  margin-bottom: 20px;
  span {
    font-size: 14px;
    margin-right: 10px;
  }
}

</style>
